import React from 'react';
const Navbar = () => {
  return <nav className="sticky top-0 z-50 w-full bg-[#faf7f2]/80 backdrop-blur-sm border-b border-[#e9e2d9]" data-id="element-182">
      <div className="container mx-auto px-4 py-4 flex justify-center items-center" data-id="element-183">
        <h1 className="text-xl font-serif font-medium text-[#b76e79]" data-id="element-184">
          Belleza Latina
        </h1>
      </div>
    </nav>;
};
export default Navbar;